<template>
  <div>

    <validation-observer ref="form">
      <b-form @submit.prevent="save">
        <div class="w-full flex gap-2 justify-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              @click="showResponsablePopupSearch = true"
              class="float-right">
              <feather-icon
                    icon="SearchIcon"
                    class="mr-50"/>
              <span class="align-middle">Buscar</span>
            </b-button>
            <!--
            <b-button variant="outline-primary" @click="showResponsablePopupInclude = true" class="float-right mr-2">
              <feather-icon
                icon="PlusIcon"
                class="mr-50"/>
              <span class="align-middle">Incluir</span>
            </b-button>
            -->
        </div>
      </b-form>
    </validation-observer>

    <user-popup
            :visible="showResponsablePopupSearch"
            @selected="addResponsablesList"
            @close="closePopup"
            :filters="filtersGridResponsable"/>

    <div class="vx-row mt-4 mb-10">
      <div class="vx-col w-full">
        <vs-table :data="responsablesList" no-data-text="Nenhum registro encontrado">
          <template slot="thead">
            <vs-th>Nome</vs-th>
            <vs-th>E-mail</vs-th>
            <!-- <vs-th>Principal</vs-th>-->
            <vs-th>Ação</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{data[indextr].name}}</vs-td>
              <vs-td>{{data[indextr].email}}</vs-td>
              <!--
              <vs-td>
                <span v-if="data[indextr].head">Sim</span>
                <span v-else>Não</span>
              </vs-td>
              -->
              <vs-td>
                <div class="flex flex-row gap-2">
                  <feather-icon
                    icon="Trash2Icon"
                    style="cursor: pointer;"
                    class="h-5 w-5 mr-1 stroke-current text-danger"
                    @click="destroy(data[indextr])"/>
                  </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BForm, BButton, BFormInput, BFormGroup, BFormCheckbox, BInputGroupAppend, BInputGroup
} from 'bootstrap-vue'
import { required, email } from '@validations'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

import UserPopup from '../../users/UserPopup.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    vSelect,
    // BSV
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BFormCheckbox,
    BInputGroupAppend,
    BInputGroup,
    // validations
    ValidationProvider,
    ValidationObserver,
    //
    UserPopup
  },
  props: {
    services: {
      type: Object,
      default: null
    },
    legalEntityId: {
      type: Number,
      default: null
    },
  },
  data: () => ({
    id: null,
    showResponsablePopupSearch: false,
    showResponsablePopupInclude: false,
    responsable: {
      document: null,
      name: null,
      email: null,
    },
    responsablesList: [],
    editMode: false,
    // validation rules
    required,
  }),
  computed: {
    validateForm() {
      return (
        // !this.errors.any() && //vee-validate-fix
        !this.isEmpty(this.responsable.name) &&
        !this.isEmpty(this.responsable.email)
      )
    }
  },
  watch: {},
  methods: {
    save() {

    },
    destroy(entity) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirmação',
        acceptText: 'Sim',
        cancelText: 'Não',
        text: 'Tem certeza que deseja excluir este registro?',
        accept: () => {
          this.acceptDestroy(entity)
        }
      })
    },
    acceptDestroy(entity) {
      this.$vs.loading()
      this.services.legalEntityService.destroyResponsable(this.legalEntityId, entity.id)
        .then(
          data => {
            this.$vs.loading.close()
            this.responsablesList = this.responsablesList.filter(element => {
              return element.id !== entity.id
            })

            this.notifySuccess(this.$vs)
          },
          error => {
            this.$vs.loading.close()
            this.showErrors(this.$validator, error)
          }
        )
    },
    clearFields() {
      this.responsable.name = null
      this.responsable.email = null
    },
    loadData() {
      this.services.legalEntityService.getAllResponsables(this.legalEntityId).then(
        response => {
          this.responsablesList = Array.from(response)
        },
        error => {this.$vs.loading.close()}
      ).finally(() => {this.$vs.loading.close()})
    },
    addResponsablesList(list = null) {
      if (list && this._.isArray(list) && list.length > 0) {
        const entityList = []

        list.forEach(
          (entity) => entityList.push(entity)
        )
        this.addResponsables(entityList)
      }
    },
    addResponsables(ids) {
      this.$vs.loading()
      if (this.legalEntityId) {
        this.services.legalEntityService.attachResponsable(this.legalEntityId, ids).then(
          response => {
            this.notifySuccess(this.$vs, this.$t('messages.success'))
            this.loadData()
          },
          error => {this.notifyError(this.$vs, 'Não foi possível adicionar o responsável!')}
        ).finally(() => {this.$vs.loading.close()})
      }
    },
    updateGrid() {
      this.loadData()
    },
    closePopup(show) {
      this.showResponsablePopupSearch = show
    },
  },
  beforeMount() {

  },
  beforeDestroy() {

  },
  mounted() {
    this.loadData()
  }
}
</script>
